import React from "react";
import { PieChart } from "@mui/x-charts/PieChart";

interface PieData {
  id: number;
  value: number;
  label: string;
  color?: string;
}

const MuiPieChart: React.FC<{ data: PieData[] }> = ({ data }) => {
  return (
    <PieChart
      series={[
        {
          data,
          innerRadius: 0, // full pie
          outerRadius: 100,
          paddingAngle: 4,
          arcLabel: (item) => `${item.label}: ${item.value}%`,
        },
      ]}
      width={420}
      height={300}
      colors={data.map((d) => d.color || "#2196f3")}
      sx={{
        [`& .MuiChartsArcLabel-root`]: {
          fill: "#000",
          fontWeight: 500,
          fontSize: 13,
        },
      }}
      slotProps={{
        legend: {
          direction: "row",
          position: {
            vertical: "bottom",
            horizontal: "middle",
          },
          itemMarkWidth: 12,
          itemMarkHeight: 12,
          markGap: 6,
          itemGap: 18,
          labelStyle: {
            fontSize: 14,
            fontWeight: 500,
          },
        },
      }}
    />
  );
};

export default MuiPieChart;
